import React, { useEffect, useState } from 'react';
import FullPageSyncLoader from 'components/FullPageSyncLoader';

import SectionWrapper from 'components/SectionWrapper/SectionWrapper';

import MensajeRecordatorios from 'types/models/mensajes-recordatorios';
import mensajesRecordatoriosService from 'services/remote/MensajeRecordatorioService';
import { SectionTitle } from 'components';
import styles from './MensajeRecordatorioPage.module.scss';
import { MensajeRecordatorioListTable } from './mensaje-recordatorio-list-table/mensaje-recordatorio-list-table';

export const MensajeRecordatorioPage = (): JSX.Element => {
  const [AllMensajeRecordatorio, setMensajeRecordatorio] = useState<MensajeRecordatorios[]>([]);
  const [loadingData, setLoadingData] = useState<boolean>(true);

  useEffect(() => {
    mensajesRecordatoriosService
      .getAll()
      .then((response) => {
        setMensajeRecordatorio(response); 
      })
      .finally(() => {
        setLoadingData(false);
      });
  }, []);

  return (
    <div className={styles.container2}>
      <SectionWrapper>
        <SectionTitle text="Mensajes de onboarding" />

        <div className={styles.table_wrapper}>
          {loadingData ? <FullPageSyncLoader icon /> : <MensajeRecordatorioListTable data={AllMensajeRecordatorio} />}
        </div>
      </SectionWrapper>
    </div>
  );
};
